import React from 'react'
import { motion } from "framer-motion";
import { NavLink } from 'react-router-dom';
import OptimizedImage from "./OptimizedImage";

const HomeSection6 = ({ section6, Section6InView, i18n }) => {
    return (
        <div>
            {/* <!-- ===== LET’S HAVE A MEETING ... FOR FREE ===== --> */}
            <section className="w-100" style={{ background: Number(section6.use_bg_color) === 1 && section6.bg_color1 && section6.bg_color2 ? `linear-gradient(to right, ${section6.bg_color1}, ${section6.bg_color2})` : "linear-gradient(rgba(167, 232, 255, 0.9), rgba(205, 255, 226, 0.7))" }}>
                <div className="container">
                    <div className="card mb-3 p-3" style={{ background: "none", border: "none" }}>
                        <div className="row g-0">
                            <div className="col-12 col-md-10">
                                <div className=" col-12 col-lg-8 card-body">
                                    <motion.h5
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 1, delay: 0 }}
                                        className="card-title"> {i18n.language === "en" ? section6?.titleEn : section6?.titleAr}</motion.h5>
                                    <motion.p
                                        initial={{ opacity: 0, x: -50 }}
                                        whileInView={{ opacity: 1, x: 0 }}
                                        viewport={{ once: true }}
                                        transition={{ duration: 1, delay: 0 }}
                                        className="card-text">
                                        {i18n.language === "en" ? section6?.descriptionEn : section6?.descriptionAr}
                                    </motion.p>
                                    {(section6?.btnEn || section6?.btnAr) && (
                                        <NavLink to="/contact-us">
                                            <motion.button
                                                initial={{ opacity: 0, x: -50 }}
                                                whileInView={{ opacity: 1, x: 0 }}
                                                viewport={{ once: true }}
                                                transition={{ duration: 1, delay: 0.5 }}
                                                className="hero-button" style={{ borderRadius: "5px" }}> {i18n.language === "en" ? section6?.btnEn : section6?.btnAr}</motion.button>
                                        </NavLink>
                                    )}
                                </div>
                            </div>
                            <div className="col-12 col-md-2 mt-5">
                                <motion.div
                                    initial={{ opacity: 0, x: 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 1, delay: 0.75 }}
                                >
                                    <OptimizedImage
                                        src={section6.img}
                                        alt={section6.alt || "meetingImg"}
                                        className="img-fluid"
                                        width={220}
                                        height={160}
                                        objectFit="contain"
                                        style={{ borderRadius: "40px" }}
                                    />
                                </motion.div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default HomeSection6
